import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, ShieldAlert, FileText, Plug, Download, Globe } from 'lucide-react';

const ComplianceSidebarNav = ({ projectId }) => {
  const location = useLocation();
  const basePath = `/compliance/projects/${projectId}`;

  const subNavItems = [
    { name: 'Dashboard', path: basePath, icon: LayoutDashboard, exact: true },
    { name: 'Risk Assessment', path: `${basePath}/risk-assessment`, icon: ShieldAlert },
    { name: 'Policies', path: `${basePath}/policies`, icon: FileText },
    { name: 'Integrations', path: `${basePath}/integrations`, icon: Plug },
    { name: 'Export', path: `${basePath}/export`, icon: Download },
    { name: 'Trust Center', path: `${basePath}/trust-center`, icon: Globe },
  ];

  const isActive = (item) => {
    if (item.exact) {
      return location.pathname === item.path;
    }
    return location.pathname.startsWith(item.path);
  };

  return (
    <div className="ml-4 mt-1 flex flex-col gap-0.5">
      {subNavItems.map((item) => {
        const Icon = item.icon;
        const active = isActive(item);
        return (
          <Link
            key={item.name}
            to={item.path}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm transition-colors ${
              active
                ? 'bg-teal-50 text-teal-700 font-medium'
                : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
            }`}
          >
            <Icon className="w-3.5 h-3.5" />
            {item.name}
          </Link>
        );
      })}
    </div>
  );
};

export default ComplianceSidebarNav;
